import { NavLink } from "react-router-dom";
import { AiModelsNavDropdown } from "./AiModelsNavDropdown";
import { HeaderCustomerTools } from "./HeaderCustomerTools";
import { NavDropdown } from "./NavDropdown";
import { SITE_NAV } from "../config/siteNav";

export function SiteHeader() {
  return (
    <header className="header">
      <div className="header-inner">
        <NavLink to="/" className="brand" end>
          <img
            className="brand-logo"
            src="/logo/aitrainingservice.png"
            alt="TNKTrade"
            width={40}
            height={40}
          />
          <span className="brand-text">TNKTrade</span>
        </NavLink>
        <nav className="primary-nav" aria-label="Main">
          {SITE_NAV.map((item) =>
            item.slug === "ai-models" ? (
              <AiModelsNavDropdown key={item.slug} item={item} />
            ) : (
              <NavDropdown key={item.slug} item={item} />
            ),
          )}
        </nav>
        <HeaderCustomerTools />
      </div>
    </header>
  );
}
